import * as Yup from "yup";

export const selectObjectCreator = (name, key) => {
  return {
    value: name,
    label: name,
    id: key,
    key: key
  }
};

export const initialValuesCreator = (data) => {
  let initialValuesObj = {};
  const keys = Object.keys(data);
  const values = Object.values(data);
  keys.map((key, i) => {
    const elem = values[i];
    if (elem.type === 'object') {
      initialValuesObj[key] = selectObjectCreator(elem.choices[0].name, elem.choices[0].key)
    } else if (elem.type === 'boolean') {
      initialValuesObj[key] = (elem.value
        && selectObjectCreator('Yes', elem.value))
        || selectObjectCreator('No', false);
    } else {
      initialValuesObj[key] = elem.value;
    }
    return key;
  });
  return initialValuesObj;
};
const regexpGenerator = (number) => {
  number = number + '';
  let regex = '^';
  if (number <= 9) {
    regex += '[0-9]'
  } else if (number > 9 && number <= 99) {
    regex += '([0-9]';
    for (let i = 1; i < number[0]; i++) {
      regex += '|' + i + '[0-9]';
    }
    regex += '|' + number[0] + '[0-' + number[1] + '])'
  }
  return new RegExp(regex +'$' );
};

export const validationSchemaCreator = (data) => {
  const keys = Object.keys(data);
  const values = Object.values(data);
  let validationObject = {};
  keys.map((key, i) => {
    if (values[i].type === 'integer') {
      if (values[i].hasOwnProperty('maximum')) {
        validationObject[key] = Yup.string().matches(regexpGenerator(values[i].maximum), 'Must be integer max ' + values[i].maximum);
      } else {
        validationObject[key] = Yup.string().matches(/^[0-9]*$/, 'Must be integer');
      }

    } else if (values[i].type === 'number') {
      if (values[i].hasOwnProperty('maximum')) {

        validationObject[key] = Yup.string().matches(regexpGenerator(values[i].maximum), 'Must be integer max ' + values[i].maximum);
      } else {
        validationObject[key] = Yup.string().matches(/^[.0-9]*$/, 'Must be number');
      }
    } else if (values[i].hasOwnProperty('list')) {
      validationObject[key] = Yup.string().matches(/^[,0-9]*$/, 'Must be number or comma');
    }
  });
  return Yup.object().shape(validationObject);
};


// WEBPACK FOOTER //
// ./src/views/AssetSchemas/AssetSchemas/EditSchema/dataDef.js